<script>
  import { onMount } from 'svelte'
  import chroma from 'chroma-js'
  export let scale = chroma.scale(['#3B3B3B', 'hotpink']).domain([0, 100])

  import HeatTable from '../components/HeatTable.svelte'
  let hours = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23,
  ]

  let labelHours = ['Midnight', '6am', '12pm', '6pm']
  let promise = false
  export let tweets
  export let label
  export let aid, atext, atarget

  let day0 = []
  let day1 = []
  let day2 = []
  let day3 = []
  let day4 = []
  let day5 = []
  let day6 = []
  let day7 = []
  let day8 = []
  let day9 = []
  let day10 = []
  let day11 = []
  let day12 = []

  hours.forEach((d) => {
    day0.push(hours)
    day1.push(tweets['2021-07-08'][d])
    day2.push(tweets['2021-07-09'][d])
    day3.push(tweets['2021-07-10'][d])
    day4.push(tweets['2021-07-11'][d])
    day5.push(tweets['2021-07-12'][d])
    day6.push(tweets['2021-07-13'][d])
    day7.push(tweets['2021-07-14'][d])
    day8.push(tweets['2021-07-15'][d])
    day9.push(tweets['2021-07-16'][d])
  })
  onMount(() => {
    promise = true
  }, 2000)
  // setAnnotation(aid, atarget)

  function setAnnotation(id, target) {
    setTimeout(() => {
      let boxWidth = document.querySelector('.tweets').offsetWidth
      let a = document.getElementById(id)
      let aHeight = a.offsetHeight
      let x = document.getElementById(target).offsetLeft
      let y = document.getElementById(target).offsetTop
      a.style.left = x - boxWidth / 1.5 + 'px'

      a.style.top = y - (aHeight - 10) + 'px'
    }, 500)
  }
</script>

<div class="tweet-block">
  <div class="tweet-wrap-title">{label}</div>
  <div class="tweet-legend">
    <div>0 tweets</div>
    <div class="legend-blocks">
      <div class="block" style="background: {scale(0)};" />
      <div class="block" style="background: {scale(20)};" />
      <div class="block" style="background: {scale(40)};" />
      <div class="block" style="background: {scale(60)};" />
      <div class="block" style="background: {scale(80)};" />
      <div class="block" style="background: {scale(100)};" />
    </div>
    <div>Max tweets</div>
  </div>
  <div class="tweet-wrap">
    <div class="tweets-label tweets-head tweet-time">Time:</div>
    <div class="tweet-row">
      {#each labelHours as h}
        <div class="tweets tweets-head">{h}</div>
      {/each}
    </div>
  </div>

  {#if promise}
    <!-- <div id={aid} class="annotation annotationa">
      <div class="annotation-label">{atext}</div>
      <div class="annotation-arrow">
        <img src="/images/arrow-left.png" alt="Arrow marker" />
      </div>
    </div> -->
  {/if}
  <HeatTable label="8 July" id="a" day={day1} />
  <HeatTable label="9 July" id="b" day={day2} />
  <HeatTable label="10 July" id="c" day={day3} />
  <HeatTable label="11 July" id="d" day={day4} />
  <HeatTable label="12 July" id="e" day={day5} />
  <HeatTable label="13 July" id="f" day={day6} />
  <HeatTable label="14 July" id="g" day={day7} />
  <HeatTable label="15 July" id="h" day={day8} />
  <HeatTable label="16 July" id="h" day={day9} />
</div>

<style>
  .tweets {
    text-align: left;
    border-left: solid 1px rgb(126, 126, 126);
    padding: 0px;
    color: #fff;
    font-weight: 700;
    font-size: 0.9rem;
  }
  .tweet-legend {
    display: grid;
    grid-template-columns: auto auto auto;
    width: 250px;
  }
  .legend-blocks {
    width: 50px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  }
  .block {
    width: 10px;
    height: 10px;
    margin-top: 3px;
  }
  .tweet-time {
    /* padding-top: 10px; */
    /* padding-right: 10px; */
    text-align: center;
  }
  .annotation {
    position: absolute;
    top: 10px;
    left: 10px;
    font-size: 0.8rem;
    font-weight: 700;
    color: #fff;
    /* border: solid 1px red; */
    display: none;
  }
  .annotation-label {
    transform: translate(45px, 0px);
    max-width: 300px;
    line-height: 0.9rem;
    text-shadow: 0px 0px 10px #000000;
    font-size: 1rem;
  }

  .tweet-wrap-title {
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 20px;
    width: 100%;
    text-align: center;
  }
  .tweet-block {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .tweet-row {
    padding: 0px;
    margin: 0px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  .tweet-legend {
    text-transform: uppercase;
    font-size: 0.7rem;
    margin-bottom: 5px;
  }
  .tweet-block {
  }
  .tweets-head {
    padding-left: 5px;
  }
</style>
